export const DEFAULT_LIMITApi = 100;
export const DEFAULT_ES_LIMITApi = 50;
export const MAX_ES_LIMITApi = 500;
export const ES_GEO_DISTANCEApi = 50;
export const ES_LOCAL_GEO_DISTANCEApi = 150;
export const ES_LOCAL_SKILL_GEO_DISTANCEApi = 25;
export const MAX_LIMITApi = 5000;
export const ES_DIRECTORY_LIMITApi = 10;
export const ES_LOCAL_DIRECTORY_LIMITApi = 20;
export const ADMIN_PERSPECTIVEApi = -99;
export const LOGGED_OUT_PERSPECTIVEApi = -1;
export const LOGGED_IN_PERSPECTIVEApi = -10;
export const MIN_SHARED_GAF_EXCEPTION_CODESApi = 10000;
export const NO_LIMITApi = -1;
export const PORTFOLIO_ITEMS_LIMITApi = 5;
export const PORTFOLIO_ITEMS_OFFSETApi = 0;
export const ARTICLES_LIMITApi = 5;
export const ARTICLES_OFFSETApi = 0;
export const DEFAULT_CONTEST_ROOT_MESSAGES_LIMITApi = 50;
export const DEFAULT_CONTEST_REPLY_MESSAGES_LIMITApi = 2;
export const DEFAULT_CONTEST_MESSAGES_OFFSETApi = 0;
export const USER_CERTIFICATIONS_LIMITApi = 5;
export const DEFAULT_USER_DISCOVER_COLLECTIONS_LIMITApi = 12;
export const DEFAULT_USER_DISCOVER_COLLECTIONS_OFFSETApi = 0;
export const DEFAULT_USER_DISCOVER_COLLECTION_ITEMS_LIMITApi = 12;
export const DEFAULT_USER_DISCOVER_COLLECTION_ITEMS_OFFSETApi = 0;
export const TEXT_ENTITIES_LIMITApi = 200;
export var ThriftPortsApi;
(function (ThriftPortsApi) {
    ThriftPortsApi["GRAPH"] = "graph";
    ThriftPortsApi["FILESERVICE_KEYS"] = "fileservice_keys";
    ThriftPortsApi["FILESERVICE_META"] = "fileservice_meta";
    ThriftPortsApi["USER"] = "user";
    ThriftPortsApi["PROJECT"] = "project";
    ThriftPortsApi["MESSAGES"] = "messages";
    ThriftPortsApi["CONTACTS"] = "contacts";
    ThriftPortsApi["MESSAGES_SMTP"] = "messages_smtp";
    ThriftPortsApi["NEWSFEED"] = "newsfeed";
    ThriftPortsApi["NEWSFEED_PROPAGATOR"] = "newsfeed_propagator";
    ThriftPortsApi["TRANSLATIONS"] = "translations";
    ThriftPortsApi["MEMBERSHIPS"] = "memberships";
    ThriftPortsApi["TASKQUEUE"] = "taskqueue";
    ThriftPortsApi["ABTEST"] = "abtest";
    ThriftPortsApi["EMAILS"] = "emails";
    ThriftPortsApi["EMAILS_MIGRATION"] = "emails_migration";
    ThriftPortsApi["PII_STORE"] = "pii_store";
    ThriftPortsApi["USERS_DAO"] = "users_dao";
    ThriftPortsApi["PROJECTS_DAO"] = "projects_dao";
    ThriftPortsApi["MESSAGES_DAO"] = "messages_dao";
    ThriftPortsApi["CONTACTS_DAO"] = "contacts_dao";
    ThriftPortsApi["GAF"] = "gaf";
    ThriftPortsApi["EMAILS_UNRESTRICTED"] = "emails_unrestricted";
    ThriftPortsApi["LANGUAGE"] = "language";
    ThriftPortsApi["NEON"] = "neon";
    ThriftPortsApi["AUTH_CA"] = "auth_ca";
    ThriftPortsApi["AUTH_SESSION"] = "auth_session";
    ThriftPortsApi["AUTH_USER"] = "auth_user";
    ThriftPortsApi["AUTH_ADMIN"] = "auth_admin";
    ThriftPortsApi["AUTH_LOGGER"] = "auth_logger";
    ThriftPortsApi["AUTH_BLOB"] = "auth_blob";
    ThriftPortsApi["AUTH_FASTLOGIN"] = "auth_fastlogin";
})(ThriftPortsApi || (ThriftPortsApi = {}));
export var ContextTypeApi;
(function (ContextTypeApi) {
    ContextTypeApi["NONE"] = "none";
    ContextTypeApi["PROJECT"] = "project";
    ContextTypeApi["CONTEST"] = "contest";
})(ContextTypeApi || (ContextTypeApi = {}));
export var CheckFieldsApi;
(function (CheckFieldsApi) {
    CheckFieldsApi["EACH"] = "each";
    CheckFieldsApi["ALL"] = "all";
})(CheckFieldsApi || (CheckFieldsApi = {}));
export var RemovalReasonApi;
(function (RemovalReasonApi) {
    RemovalReasonApi["CONTACTS"] = "contacts";
    RemovalReasonApi["ADVERTISING"] = "advertising";
    RemovalReasonApi["HARASSMENT"] = "harassment";
    RemovalReasonApi["FAKE"] = "fake";
    RemovalReasonApi["NONFEATURED"] = "nonfeatured";
    RemovalReasonApi["OTHER"] = "other";
    RemovalReasonApi["OFFSITING"] = "offsiting";
    RemovalReasonApi["MILESTONE_RELEASE_ABUSE"] = "milestone_release_abuse";
    RemovalReasonApi["PRIVACY_DELETE"] = "privacy_delete";
    RemovalReasonApi["OWNER_DELETE"] = "owner_delete";
    RemovalReasonApi["SPAM"] = "spam";
    RemovalReasonApi["DISCLOSING_PERSONAL_DETAILS"] = "disclosing_personal_details";
    RemovalReasonApi["SCAM"] = "scam";
    RemovalReasonApi["OFFENSIVE"] = "offensive";
    RemovalReasonApi["IRRELEVANT"] = "irrelevant";
    RemovalReasonApi["DOWNVOTED"] = "downvoted";
    RemovalReasonApi["LOOKING_FOR_WORK"] = "looking_for_work";
    RemovalReasonApi["SUPPORT_REQUEST"] = "support_request";
})(RemovalReasonApi || (RemovalReasonApi = {}));
export var ActionSourceTypeApi;
(function (ActionSourceTypeApi) {
    ActionSourceTypeApi["FLN_ADMIN"] = "fln_admin";
    ActionSourceTypeApi["USER"] = "user";
})(ActionSourceTypeApi || (ActionSourceTypeApi = {}));
export var EquipmentGroupContextTypeApi;
(function (EquipmentGroupContextTypeApi) {
    EquipmentGroupContextTypeApi["PROJECT"] = "project";
    EquipmentGroupContextTypeApi["USER"] = "user";
    EquipmentGroupContextTypeApi["USER_AVAILABILITY"] = "user_availability";
})(EquipmentGroupContextTypeApi || (EquipmentGroupContextTypeApi = {}));
export var RemoveFromTimeApi;
(function (RemoveFromTimeApi) {
    RemoveFromTimeApi["ALL"] = "all";
    RemoveFromTimeApi["LAST_DAY"] = "last_day";
    RemoveFromTimeApi["LAST_WEEK"] = "last_week";
    RemoveFromTimeApi["LAST_MONTH"] = "last_month";
})(RemoveFromTimeApi || (RemoveFromTimeApi = {}));
export var RoleApi;
(function (RoleApi) {
    RoleApi["FREELANCER"] = "freelancer";
    RoleApi["EMPLOYER"] = "employer";
})(RoleApi || (RoleApi = {}));
export var SourceApi;
(function (SourceApi) {
    SourceApi["UNIT_TEST_1"] = "unit_test_1";
    SourceApi["UNIT_TEST_2"] = "unit_test_2";
    SourceApi["UNIT_TEST_3"] = "unit_test_3";
    SourceApi["SEARCH_RESULT"] = "search_result";
    SourceApi["SUPERUSER_SEARCH_RESULT"] = "superuser_search_result";
    SourceApi["OTHER"] = "other";
})(SourceApi || (SourceApi = {}));
export var TimeUnitApi;
(function (TimeUnitApi) {
    TimeUnitApi["SECOND"] = "second";
    TimeUnitApi["MINUTE"] = "minute";
    TimeUnitApi["HOUR"] = "hour";
    TimeUnitApi["DAY"] = "day";
    TimeUnitApi["WEEK"] = "week";
    TimeUnitApi["MONTH"] = "month";
    TimeUnitApi["YEAR"] = "year";
    TimeUnitApi["DECADE"] = "decade";
    TimeUnitApi["CENTURY"] = "century";
    TimeUnitApi["MILLENIUM"] = "millenium";
})(TimeUnitApi || (TimeUnitApi = {}));
export var HashAlgorithmApi;
(function (HashAlgorithmApi) {
    HashAlgorithmApi["MD5"] = "md5";
    HashAlgorithmApi["SHA1"] = "sha1";
    HashAlgorithmApi["SHA224"] = "sha224";
    HashAlgorithmApi["SHA256"] = "sha256";
    HashAlgorithmApi["SHA384"] = "sha384";
    HashAlgorithmApi["SHA512"] = "sha512";
    HashAlgorithmApi["RIPEMD160"] = "ripemd160";
})(HashAlgorithmApi || (HashAlgorithmApi = {}));
export var SourceTypeApi;
(function (SourceTypeApi) {
    SourceTypeApi["IOS"] = "ios";
    SourceTypeApi["ANDROID"] = "android";
    SourceTypeApi["MOBILE"] = "mobile";
    SourceTypeApi["DESKTOP"] = "desktop";
    SourceTypeApi["OTHER"] = "other";
})(SourceTypeApi || (SourceTypeApi = {}));
export var DepositMethodApi;
(function (DepositMethodApi) {
    DepositMethodApi["PAYPAL"] = "paypal";
    DepositMethodApi["FLN_BILLING"] = "fln_billing";
    DepositMethodApi["SKRILL"] = "skrill";
    DepositMethodApi["WEB_MONEY"] = "web_money";
    DepositMethodApi["WIRE"] = "wire";
    DepositMethodApi["PAYPAL_REFERENCE"] = "paypal_reference";
    DepositMethodApi["BOLETO"] = "boleto";
    DepositMethodApi["ALIPAY"] = "alipay";
    DepositMethodApi["UNION_PAY"] = "union_pay";
    DepositMethodApi["IDEAL"] = "ideal";
    DepositMethodApi["SOFORT"] = "sofort";
    DepositMethodApi["GIROPAY"] = "giropay";
    DepositMethodApi["INTERAC"] = "interac";
    DepositMethodApi["BANCONTACT"] = "bancontact";
    DepositMethodApi["DOTPAY"] = "dotpay";
    DepositMethodApi["PAYTM"] = "paytm";
    DepositMethodApi["PAYTM_SUBSCRIPTION"] = "paytm_subscription";
    DepositMethodApi["WECHATPAY"] = "wechatpay";
    DepositMethodApi["GOOGLEPAY"] = "googlepay";
    DepositMethodApi["APPLEPAY"] = "applepay";
    DepositMethodApi["LOC"] = "loc";
    DepositMethodApi["DEV_CREDITS"] = "dev_credits";
    DepositMethodApi["EPHEMERAL_CREDITS"] = "ephemeral_credits";
    DepositMethodApi["TEAM_BILLING"] = "team_billing";
    DepositMethodApi["ENTERPRISE_BILLING"] = "enterprise_billing";
})(DepositMethodApi || (DepositMethodApi = {}));
export const ESCROW_COM_CURRENCIESApi = [
    'USD',
    'AUD',
    'EUR',
];
export const RemovalReasonKeysApi = {
    [RemovalReasonApi.CONTACTS]: 'Contacts',
    [RemovalReasonApi.ADVERTISING]: 'Advertising',
    [RemovalReasonApi.HARASSMENT]: 'Harassment',
    [RemovalReasonApi.FAKE]: 'Fake',
    [RemovalReasonApi.NONFEATURED]: 'Non-featured',
    [RemovalReasonApi.OTHER]: 'Other',
    [RemovalReasonApi.OFFSITING]: 'Offsiting',
    [RemovalReasonApi.MILESTONE_RELEASE_ABUSE]: 'MilestoneHarassment',
    [RemovalReasonApi.PRIVACY_DELETE]: 'PrivacyDelete',
    [RemovalReasonApi.OWNER_DELETE]: 'OwnerDelete',
    [RemovalReasonApi.SPAM]: 'Spam',
    [RemovalReasonApi.DISCLOSING_PERSONAL_DETAILS]: 'DisclosingPersonalDetails',
    [RemovalReasonApi.SCAM]: 'Scam',
    [RemovalReasonApi.OFFENSIVE]: 'Offensive',
    [RemovalReasonApi.IRRELEVANT]: 'Irrelevant',
    [RemovalReasonApi.DOWNVOTED]: 'Downvoted',
    [RemovalReasonApi.LOOKING_FOR_WORK]: 'LookingForWork',
    [RemovalReasonApi.SUPPORT_REQUEST]: 'SupportRequest',
};
export var ExternalAccountTypeApi;
(function (ExternalAccountTypeApi) {
    ExternalAccountTypeApi["PHONE_NUMBER"] = "phone_number";
    ExternalAccountTypeApi["FACEBOOK"] = "facebook";
    ExternalAccountTypeApi["TWITTER"] = "twitter";
    ExternalAccountTypeApi["LINKEDIN"] = "linkedin";
    ExternalAccountTypeApi["GOOGLE"] = "google";
    ExternalAccountTypeApi["EMAIL"] = "email";
})(ExternalAccountTypeApi || (ExternalAccountTypeApi = {}));
export var CommissionFeeTypeApi;
(function (CommissionFeeTypeApi) {
    CommissionFeeTypeApi["FLAT"] = "flat";
    CommissionFeeTypeApi["RATE"] = "rate";
})(CommissionFeeTypeApi || (CommissionFeeTypeApi = {}));
export var InsigniaTypeApi;
(function (InsigniaTypeApi) {
    InsigniaTypeApi["EXAM"] = "exam";
    InsigniaTypeApi["EXTERNAL_QUALIFICATION"] = "external_qualification";
})(InsigniaTypeApi || (InsigniaTypeApi = {}));
export var FrontendProjectStatusApi;
(function (FrontendProjectStatusApi) {
    FrontendProjectStatusApi["OPEN"] = "open";
    FrontendProjectStatusApi["WORK_IN_PROGRESS"] = "work_in_progress";
    FrontendProjectStatusApi["COMPLETE"] = "complete";
    FrontendProjectStatusApi["PENDING"] = "pending";
    FrontendProjectStatusApi["DRAFT"] = "draft";
})(FrontendProjectStatusApi || (FrontendProjectStatusApi = {}));
export var FrontendBidStatusApi;
(function (FrontendBidStatusApi) {
    FrontendBidStatusApi["ACTIVE"] = "active";
    FrontendBidStatusApi["IN_PROGRESS"] = "in_progress";
    FrontendBidStatusApi["COMPLETE"] = "complete";
})(FrontendBidStatusApi || (FrontendBidStatusApi = {}));
export var PoolApi;
(function (PoolApi) {
    PoolApi["FREELANCER"] = "freelancer";
    PoolApi["DELOITTE_DC"] = "deloitte_dc";
    PoolApi["ARROW_PRIVATE"] = "arrow_private";
    PoolApi["FACEBOOK"] = "facebook";
    PoolApi["API_E2E"] = "api_e2e";
    PoolApi["FLNLTD"] = "flnltd";
    PoolApi["NOKIA"] = "nokia";
    PoolApi["JOHNSON_AND_JOHNSON"] = "johnson_and_johnson";
    PoolApi["IBM"] = "ibm";
    PoolApi["FREIGHTLANCER"] = "freightlancer";
    PoolApi["DELOITTE_FTN"] = "deloitte_ftn";
})(PoolApi || (PoolApi = {}));
export var EnterpriseApi;
(function (EnterpriseApi) {
    EnterpriseApi["DELOITTE_DC"] = "deloitte_dc";
    EnterpriseApi["ARROW"] = "arrow";
    EnterpriseApi["FACEBOOK"] = "facebook";
    EnterpriseApi["PMI"] = "pmi";
    EnterpriseApi["FLNLTD"] = "flnltd";
    EnterpriseApi["AIRBUS"] = "airbus";
    EnterpriseApi["YARA"] = "yara";
    EnterpriseApi["NOKIA"] = "nokia";
    EnterpriseApi["IBM"] = "ibm";
    EnterpriseApi["FREIGHTLANCER"] = "freightlancer";
    EnterpriseApi["HP"] = "hp";
    EnterpriseApi["GELATO"] = "gelato";
})(EnterpriseApi || (EnterpriseApi = {}));
export var EnterpriseSourceApi;
(function (EnterpriseSourceApi) {
    EnterpriseSourceApi["ARROW"] = "arrow";
    EnterpriseSourceApi["ARROW_FLN"] = "arrow_fln";
    EnterpriseSourceApi["DELOITTE_DC"] = "deloitte_dc";
    EnterpriseSourceApi["FACEBOOK"] = "facebook";
    EnterpriseSourceApi["FREELANCER"] = "freelancer";
    EnterpriseSourceApi["PMI"] = "pmi";
})(EnterpriseSourceApi || (EnterpriseSourceApi = {}));
export var EntityTypeApi;
(function (EntityTypeApi) {
    EntityTypeApi["USER"] = "user";
    EntityTypeApi["ADMIN"] = "admin";
    EntityTypeApi["ENTERPRISE"] = "enterprise";
    EntityTypeApi["PROJECT"] = "project";
    EntityTypeApi["POOL"] = "pool";
})(EntityTypeApi || (EntityTypeApi = {}));
export const RATING_CATEGORIESApi = {
    [RoleApi.FREELANCER]: [
        'quality',
        'communication',
        'expertise',
        'professionalism',
        'hire_again',
    ],
    [RoleApi.EMPLOYER]: [
        'clarity_spec',
        'communication',
        'payment_prom',
        'professionalism',
        'work_for_again',
    ],
};
export var ReferralInvitationStatusApi;
(function (ReferralInvitationStatusApi) {
    ReferralInvitationStatusApi["PENDING"] = "pending";
    ReferralInvitationStatusApi["ACCEPTED"] = "accepted";
    ReferralInvitationStatusApi["EXISTING_USER"] = "existing_user";
    ReferralInvitationStatusApi["BONUS_PENDING"] = "bonus_pending";
    ReferralInvitationStatusApi["BONUS_RELEASED"] = "bonus_released";
})(ReferralInvitationStatusApi || (ReferralInvitationStatusApi = {}));
export var AttachmentAttachedToTypeApi;
(function (AttachmentAttachedToTypeApi) {
    AttachmentAttachedToTypeApi["POST"] = "post";
    AttachmentAttachedToTypeApi["DELIVERY_ITEM"] = "delivery_item";
    AttachmentAttachedToTypeApi["USER_AVAILABILITY"] = "user_availability";
    AttachmentAttachedToTypeApi["TASK"] = "task";
})(AttachmentAttachedToTypeApi || (AttachmentAttachedToTypeApi = {}));
export var AttachmentTypeApi;
(function (AttachmentTypeApi) {
    AttachmentTypeApi["PROJECT"] = "project";
    AttachmentTypeApi["FILE"] = "file";
    AttachmentTypeApi["DRIVE_FILE"] = "drive_file";
})(AttachmentTypeApi || (AttachmentTypeApi = {}));
export var AttachedByTypeApi;
(function (AttachedByTypeApi) {
    AttachedByTypeApi["USER"] = "user";
})(AttachedByTypeApi || (AttachedByTypeApi = {}));
export var TextEntityReferenceTypeApi;
(function (TextEntityReferenceTypeApi) {
    TextEntityReferenceTypeApi["PROJECT"] = "project";
    TextEntityReferenceTypeApi["USER"] = "user";
})(TextEntityReferenceTypeApi || (TextEntityReferenceTypeApi = {}));
export var TextEntityContextTypeApi;
(function (TextEntityContextTypeApi) {
    TextEntityContextTypeApi["POST"] = "post";
    TextEntityContextTypeApi["COMMENT"] = "comment";
})(TextEntityContextTypeApi || (TextEntityContextTypeApi = {}));
export var TaxTypeApi;
(function (TaxTypeApi) {
    TaxTypeApi["NONE"] = "none";
    TaxTypeApi["GST"] = "gst";
    TaxTypeApi["VAT"] = "vat";
    TaxTypeApi["TCS"] = "tcs";
    TaxTypeApi["TDS"] = "tds";
    TaxTypeApi["PAN"] = "pan";
    TaxTypeApi["MXIT"] = "mxit";
    TaxTypeApi["US1099K"] = "us1099k";
})(TaxTypeApi || (TaxTypeApi = {}));
export var UsTaxTypeApi;
(function (UsTaxTypeApi) {
    UsTaxTypeApi["EIN"] = "ein";
    UsTaxTypeApi["SSN"] = "ssn";
    UsTaxTypeApi["ITIN"] = "itin";
})(UsTaxTypeApi || (UsTaxTypeApi = {}));
export var ReactionTypeApi;
(function (ReactionTypeApi) {
    ReactionTypeApi["LIKE"] = "like";
    ReactionTypeApi["DISLIKE"] = "dislike";
})(ReactionTypeApi || (ReactionTypeApi = {}));
export var ReactionContextTypeApi;
(function (ReactionContextTypeApi) {
    ReactionContextTypeApi["POST"] = "post";
    ReactionContextTypeApi["COMMENT"] = "comment";
    ReactionContextTypeApi["MESSAGE"] = "message";
})(ReactionContextTypeApi || (ReactionContextTypeApi = {}));
export var SearchTypeApi;
(function (SearchTypeApi) {
    SearchTypeApi["PROJECT"] = "project";
    SearchTypeApi["USER"] = "user";
    SearchTypeApi["LOAD"] = "load";
    SearchTypeApi["CONTEST"] = "contest";
})(SearchTypeApi || (SearchTypeApi = {}));
export var SearchSavedFiltersContextTypeApi;
(function (SearchSavedFiltersContextTypeApi) {
    SearchSavedFiltersContextTypeApi["USER_AVAILABILITY"] = "user_availability";
})(SearchSavedFiltersContextTypeApi || (SearchSavedFiltersContextTypeApi = {}));
export var BidDenyReasonApi;
(function (BidDenyReasonApi) {
    BidDenyReasonApi["EMPLOYER_SPAM"] = "employer_spam";
    BidDenyReasonApi["EMPLOYER_UNCLEAR"] = "employer_unclear";
    BidDenyReasonApi["EMPLOYER_NOMILESTONE"] = "employer_nomilestone";
    BidDenyReasonApi["BOTH_BUDGET"] = "both_budget";
    BidDenyReasonApi["FREELANCER_ENOUGHWORK"] = "freelancer_enoughwork";
    BidDenyReasonApi["FREELANCER_NOSKILLS"] = "freelancer_noskills";
    BidDenyReasonApi["FREELANCER_NOTIME"] = "freelancer_notime";
    BidDenyReasonApi["OTHER"] = "other";
})(BidDenyReasonApi || (BidDenyReasonApi = {}));
export var SortDirectionApi;
(function (SortDirectionApi) {
    SortDirectionApi["ASC"] = "asc";
    SortDirectionApi["DESC"] = "desc";
})(SortDirectionApi || (SortDirectionApi = {}));
export var RichTextElementTypeApi;
(function (RichTextElementTypeApi) {
    RichTextElementTypeApi["H1"] = "h1";
    RichTextElementTypeApi["H2"] = "h2";
    RichTextElementTypeApi["H3"] = "h3";
    RichTextElementTypeApi["H4"] = "h4";
    RichTextElementTypeApi["H5"] = "h5";
    RichTextElementTypeApi["H6"] = "h6";
    RichTextElementTypeApi["OL"] = "ol";
    RichTextElementTypeApi["UL"] = "ul";
    RichTextElementTypeApi["LI"] = "li";
    RichTextElementTypeApi["DIV"] = "div";
    RichTextElementTypeApi["A"] = "a";
    RichTextElementTypeApi["SPAN"] = "span";
    RichTextElementTypeApi["TEXT"] = "text";
    RichTextElementTypeApi["EM"] = "em";
    RichTextElementTypeApi["STRONG"] = "strong";
    RichTextElementTypeApi["P"] = "p";
    RichTextElementTypeApi["VIDEO"] = "video";
    RichTextElementTypeApi["IMG"] = "img";
    RichTextElementTypeApi["TABLE"] = "table";
    RichTextElementTypeApi["TBODY"] = "tbody";
    RichTextElementTypeApi["CENTER"] = "center";
    RichTextElementTypeApi["COL"] = "col";
    RichTextElementTypeApi["COLGROUP"] = "colgroup";
    RichTextElementTypeApi["TD"] = "td";
    RichTextElementTypeApi["TH"] = "th";
    RichTextElementTypeApi["TR"] = "tr";
    RichTextElementTypeApi["SMALL"] = "small";
    RichTextElementTypeApi["SUB"] = "sub";
    RichTextElementTypeApi["SUP"] = "sup";
    RichTextElementTypeApi["PRE"] = "pre";
    RichTextElementTypeApi["CODE"] = "code";
    RichTextElementTypeApi["BLOCKQUOTE"] = "blockquote";
    RichTextElementTypeApi["FIGURE"] = "figure";
    RichTextElementTypeApi["RELATED_PORTFOLIOS"] = "related_portfolios";
    RichTextElementTypeApi["RELATED_FREELANCERS"] = "related_freelancers";
    RichTextElementTypeApi["YOUTUBE_VIDEO"] = "youtube_video";
    RichTextElementTypeApi["U"] = "u";
    RichTextElementTypeApi["BR"] = "br";
})(RichTextElementTypeApi || (RichTextElementTypeApi = {}));
export var ContentCustomizationInjectionPointApi;
(function (ContentCustomizationInjectionPointApi) {
    ContentCustomizationInjectionPointApi["PJP_SUBHEADER"] = "pjp_subheader";
    ContentCustomizationInjectionPointApi["PJP_TASK_DESCRIPTION"] = "pjp_task_description";
    ContentCustomizationInjectionPointApi["PJP_SKILLS_DESCRIPTION"] = "pjp_skills_description";
    ContentCustomizationInjectionPointApi["DASHBOARD_ONBOARDING_VIDEO"] = "dashboard_onboarding_video";
    ContentCustomizationInjectionPointApi["REJECTED_REPOST_PJP_SUBHEADER"] = "rejected_repost_pjp_subheader";
    ContentCustomizationInjectionPointApi["PREAPPROVED_REPOST_PJP_SUBHEADER"] = "preapproved_repost_pjp_subheader";
    ContentCustomizationInjectionPointApi["BIDS_DIGEST_DUAL_POSTED_EMAIL_SUBJECT"] = "bids_digest_dual_posted_email_subject";
    ContentCustomizationInjectionPointApi["BIDS_DIGEST_DUAL_POSTED_EMAIL_BODY"] = "bids_digest_dual_posted_email_body";
    ContentCustomizationInjectionPointApi["BIDS_DIGEST_NON_DUAL_POSTED_EMAIL_SUBJECT"] = "bids_digest_non_dual_posted_email_subject";
    ContentCustomizationInjectionPointApi["BIDS_DIGEST_NON_DUAL_POSTED_EMAIL_BODY"] = "bids_digest_non_dual_posted_email_body";
    ContentCustomizationInjectionPointApi["BIDS_DIGEST_NON_LINKED_EMAIL_SUBJECT"] = "bids_digest_non_linked_email_subject";
    ContentCustomizationInjectionPointApi["BIDS_DIGEST_NON_LINKED_EMAIL_BODY"] = "bids_digest_non_linked_email_body";
    ContentCustomizationInjectionPointApi["FIRST_THREE_BIDS_EMAIL_SUBJECT"] = "first_three_bids_email_subject";
    ContentCustomizationInjectionPointApi["FIRST_THREE_BIDS_EMAIL_BODY"] = "first_three_bids_email_body";
    ContentCustomizationInjectionPointApi["PROJECT_POSTED_EMAIL_SUBJECT"] = "project_posted_email_subject";
    ContentCustomizationInjectionPointApi["PROJECT_POSTED_EMAIL_BODY"] = "project_posted_email_body";
    ContentCustomizationInjectionPointApi["LINKED_EXTERNAL_PROJECT_LIVE_EMAIL_SUBJECT"] = "linked_external_project_live_email_subject";
    ContentCustomizationInjectionPointApi["LINKED_EXTERNAL_PROJECT_LIVE_EMAIL_BODY"] = "linked_external_project_live_email_body";
    ContentCustomizationInjectionPointApi["PROJECT_REJECTED_EMAIL_SUBJECT"] = "project_rejected_email_subject";
    ContentCustomizationInjectionPointApi["PROJECT_REJECTED_EMAIL_BODY"] = "project_rejected_email_body";
    ContentCustomizationInjectionPointApi["LINKED_PROJECT_AWARD_REMINDER_NO_BIDS_DUAL_POSTED_EMAIL_SUBJECT"] = "linked_project_award_reminder_no_bids_dual_posted_email_subject";
    ContentCustomizationInjectionPointApi["LINKED_PROJECT_AWARD_REMINDER_NO_BIDS_DUAL_POSTED_EMAIL_BODY"] = "linked_project_award_reminder_no_bids_dual_posted_email_body";
    ContentCustomizationInjectionPointApi["EMPLOYER_ADD_EXTERNAL_GIG_TO_STAFFIT_REMINDER_EMAIL_SUBJECT"] = "employer_add_external_gig_to_staffit_reminder_email_subject";
    ContentCustomizationInjectionPointApi["EMPLOYER_ADD_EXTERNAL_GIG_TO_STAFFIT_REMINDER_EMAIL_BODY"] = "employer_add_external_gig_to_staffit_reminder_email_body";
    ContentCustomizationInjectionPointApi["EMPLOYER_ADD_INTERNAL_GIG_TO_STAFFIT_REMINDER_EMAIL_SUBJECT"] = "employer_add_internal_gig_to_staffit_reminder_email_subject";
    ContentCustomizationInjectionPointApi["EMPLOYER_ADD_INTERNAL_GIG_TO_STAFFIT_REMINDER_EMAIL_BODY"] = "employer_add_internal_gig_to_staffit_reminder_email_body";
    ContentCustomizationInjectionPointApi["MILESTONE_REQUESTED_EMAIL_SUBJECT"] = "milestone_requested_email_subject";
    ContentCustomizationInjectionPointApi["MILESTONE_REQUESTED_EMAIL_BODY"] = "milestone_requested_email_body";
    ContentCustomizationInjectionPointApi["PROJECT_DENIED_HIREME_OR_NON_BIDDABLE_EMAIL_SUBJECT"] = "project_denied_hireme_or_non_biddable_email_subject";
    ContentCustomizationInjectionPointApi["PROJECT_DENIED_HIREME_OR_NON_BIDDABLE_EMAIL_BODY"] = "project_denied_hireme_or_non_biddable_email_body";
    ContentCustomizationInjectionPointApi["PROJECT_DENIED_ADDITIONAL_BIDS_EMAIL_SUBJECT"] = "project_denied_additional_bids_email_subject";
    ContentCustomizationInjectionPointApi["PROJECT_DENIED_ADDITIONAL_BIDS_EMAIL_BODY"] = "project_denied_additional_bids_email_body";
    ContentCustomizationInjectionPointApi["PROJECT_DENIED_NO_ADDITIONAL_BID_EMAIL_SUBJECT"] = "project_denied_no_additional_bid_email_subject";
    ContentCustomizationInjectionPointApi["PROJECT_DENIED_NO_ADDITIONAL_BID_EMAIL_BODY"] = "project_denied_no_additional_bid_email_body";
    ContentCustomizationInjectionPointApi["LINKED_PROJECT_AWARD_REMINDER_NO_BIDS_EMAIL_SUBJECT"] = "linked_project_award_reminder_no_bids_email_subject";
    ContentCustomizationInjectionPointApi["LINKED_PROJECT_AWARD_REMINDER_NO_BIDS_EMAIL_BODY"] = "linked_project_award_reminder_no_bids_email_body";
    ContentCustomizationInjectionPointApi["FROZEN_TIMEOUT_EMAIL_SUBJECT"] = "frozen_timeout_email_subject";
    ContentCustomizationInjectionPointApi["FROZEN_TIMEOUT_EMAIL_BODY"] = "frozen_timeout_email_body";
    ContentCustomizationInjectionPointApi["FIRST_PROJECT_POSTED_EMAIL_SUBJECT"] = "first_project_posted_email_subject";
    ContentCustomizationInjectionPointApi["FIRST_PROJECT_POSTED_EMAIL_BODY"] = "first_project_posted_email_body";
    ContentCustomizationInjectionPointApi["REVIEW_PENDING_EXTERNAL_EMAIL_SUBJECT"] = "review_pending_external_email_subject";
    ContentCustomizationInjectionPointApi["REVIEW_PENDING_EXTERNAL_EMAIL_BODY"] = "review_pending_external_email_body";
    ContentCustomizationInjectionPointApi["REVIEW_PENDING_INTERNAL_EMAIL_SUBJECT"] = "review_pending_internal_email_subject";
    ContentCustomizationInjectionPointApi["REVIEW_PENDING_INTERNAL_EMAIL_BODY"] = "review_pending_internal_email_body";
    ContentCustomizationInjectionPointApi["PROJECTFREEZE_AUTO_DENY_EMAIL_SUBJECT"] = "projectfreeze_auto_deny_email_subject";
    ContentCustomizationInjectionPointApi["PROJECTFREEZE_AUTO_DENY_EMAIL_BODY"] = "projectfreeze_auto_deny_email_body";
    ContentCustomizationInjectionPointApi["PROJECTFREEZE_AUTO_DENY_NO_REMAINING_BID_EMAIL_SUBJECT"] = "projectfreeze_auto_deny_no_remaining_bid_email_subject";
    ContentCustomizationInjectionPointApi["PROJECTFREEZE_AUTO_DENY_NO_REMAINING_BID_EMAIL_BODY"] = "projectfreeze_auto_deny_no_remaining_bid_email_body";
    ContentCustomizationInjectionPointApi["WON_EMAIL_SUBJECT"] = "won_email_subject";
    ContentCustomizationInjectionPointApi["WON_EMAIL_BODY"] = "won_email_body";
    ContentCustomizationInjectionPointApi["FREELANCER_ADD_GIG_TO_STAFFIT_REMINDER_EMAIL_SUBJECT"] = "freelancer_add_gig_to_staffit_reminder_email_subject";
    ContentCustomizationInjectionPointApi["FREELANCER_ADD_GIG_TO_STAFFIT_REMINDER_EMAIL_BODY"] = "freelancer_add_gig_to_staffit_reminder_email_body";
    ContentCustomizationInjectionPointApi["QUICKHIRE_POSTED_SELLER_DELOITTE_EMAIL_SUBJECT"] = "quickhire_posted_seller_deloitte_email_subject";
    ContentCustomizationInjectionPointApi["QUICKHIRE_POSTED_SELLER_DELOITTE_EMAIL_BODY"] = "quickhire_posted_seller_deloitte_email_body";
    ContentCustomizationInjectionPointApi["ALERT_BIDDERS_NOT_SELECTED_FOR_PROJECT_EMAIL_SUBJECT"] = "alert_bidders_not_selected_for_project_email_subject";
    ContentCustomizationInjectionPointApi["ALERT_BIDDERS_NOT_SELECTED_FOR_PROJECT_EMAIL_BODY"] = "alert_bidders_not_selected_for_project_email_body";
    ContentCustomizationInjectionPointApi["REMINDER_PROJECT_TO_AWARDED_FREELANCER_HIREME_EMAIL_SUBJECT"] = "reminder_project_to_awarded_freelancer_hireme_email_subject";
    ContentCustomizationInjectionPointApi["REMINDER_PROJECT_TO_AWARDED_FREELANCER_HIREME_EMAIL_BODY"] = "reminder_project_to_awarded_freelancer_hireme_email_body";
    ContentCustomizationInjectionPointApi["REMINDER_PROJECT_TO_AWARDED_FREELANCER_NON_HIREME_EMAIL_SUBJECT"] = "reminder_project_to_awarded_freelancer_non_hireme_email_subject";
    ContentCustomizationInjectionPointApi["REMINDER_PROJECT_TO_AWARDED_FREELANCER_NON_HIREME_EMAIL_BODY"] = "reminder_project_to_awarded_freelancer_non_hireme_email_body";
    ContentCustomizationInjectionPointApi["ESCROWCLEARED_EMAIL_SUBJECT"] = "escrowcleared_email_subject";
    ContentCustomizationInjectionPointApi["ESCROWCLEARED_EMAIL_BODY"] = "escrowcleared_email_body";
    ContentCustomizationInjectionPointApi["INVITATION_HOURLY_EMAIL_SUBJECT"] = "invitation_hourly_email_subject";
    ContentCustomizationInjectionPointApi["INVITATION_HOURLY_EMAIL_BODY"] = "invitation_hourly_email_body";
    ContentCustomizationInjectionPointApi["PROJECT_COLLABORATION_GENERAL_INVITATION_NEW_USER_EMAIL_SUBJECT"] = "project_collaboration_general_invitation_new_user_email_subject";
    ContentCustomizationInjectionPointApi["PROJECT_COLLABORATION_GENERAL_INVITATION_NEW_USER_EMAIL_BODY"] = "project_collaboration_general_invitation_new_user_email_body";
    ContentCustomizationInjectionPointApi["PROJECT_COLLABORATION_GENERAL_INVITATION_EXISTING_USER_EMAIL_SUBJECT"] = "project_collaboration_general_invitation_existing_user_email_subject";
    ContentCustomizationInjectionPointApi["PROJECT_COLLABORATION_GENERAL_INVITATION_EXISTING_USER_EMAIL_BODY"] = "project_collaboration_general_invitation_existing_user_email_body";
    ContentCustomizationInjectionPointApi["PROJECT_COLLABORATION_GENERAL_INVITATION_ONBEHALF_NEW_USER_EMAIL_SUBJECT"] = "project_collaboration_general_invitation_onbehalf_new_user_email_subject";
    ContentCustomizationInjectionPointApi["PROJECT_COLLABORATION_GENERAL_INVITATION_ONBEHALF_NEW_USER_EMAIL_BODY"] = "project_collaboration_general_invitation_onbehalf_new_user_email_body";
    ContentCustomizationInjectionPointApi["PROJECT_COLLABORATION_GENERAL_INVITATION_ONBEHALF_EXISTING_USER_EMAIL_SUBJECT"] = "project_collaboration_general_invitation_onbehalf_existing_user_email_subject";
    ContentCustomizationInjectionPointApi["PROJECT_COLLABORATION_GENERAL_INVITATION_ONBEHALF_EXISTING_USER_EMAIL_BODY"] = "project_collaboration_general_invitation_onbehalf_existing_user_email_body";
    ContentCustomizationInjectionPointApi["ACCEPT_ONBEHALF_PROJECT_EMAIL_SUBJECT"] = "accept_onbehalf_project_email_subject";
    ContentCustomizationInjectionPointApi["ACCEPT_ONBEHALF_PROJECT_EMAIL_BODY"] = "accept_onbehalf_project_email_body";
    ContentCustomizationInjectionPointApi["REMIND_USER_TO_COME_BACK_EMAIL_SUBJECT"] = "remind_user_to_come_back_email_subject";
    ContentCustomizationInjectionPointApi["REMIND_USER_TO_COME_BACK_EMAIL_BODY"] = "remind_user_to_come_back_email_body";
    ContentCustomizationInjectionPointApi["LATEST_PROJECTS_AND_CONTESTS_AB_TEST_EMAIL_SUBJECT"] = "latest_projects_and_contests_ab_test_email_subject";
    ContentCustomizationInjectionPointApi["LATEST_PROJECTS_AND_CONTESTS_AB_TEST_EMAIL_BODY"] = "latest_projects_and_contests_ab_test_email_body";
    ContentCustomizationInjectionPointApi["MESSAGING_NOTIFICATION_DIGEST_EMAIL_SUBJECT"] = "messaging_notification_digest_email_subject";
    ContentCustomizationInjectionPointApi["MESSAGING_NOTIFICATION_DIGEST_EMAIL_BODY"] = "messaging_notification_digest_email_body";
    ContentCustomizationInjectionPointApi["MESSAGING_NOTIFICATION_DIGEST_GROUP_CHAT_EMAIL_SUBJECT"] = "messaging_notification_digest_group_chat_email_subject";
    ContentCustomizationInjectionPointApi["MESSAGING_NOTIFICATION_DIGEST_GROUP_CHAT_EMAIL_BODY"] = "messaging_notification_digest_group_chat_email_body";
    ContentCustomizationInjectionPointApi["REVIEW_PREEXPIRED_EMAIL_SUBJECT"] = "review_preexpired_email_subject";
    ContentCustomizationInjectionPointApi["REVIEW_PREEXPIRED_EMAIL_BODY"] = "review_preexpired_email_body";
    ContentCustomizationInjectionPointApi["PROJECT_POSTER_TO_PPMD_EMAIL_SUBJECT"] = "project_poster_to_ppmd_email_subject";
    ContentCustomizationInjectionPointApi["PROJECT_POSTER_TO_PPMD_EMAIL_BODY"] = "project_poster_to_ppmd_email_body";
    ContentCustomizationInjectionPointApi["FUNDING_REQUIRED_EMAIL_SUBJECT"] = "funding_required_email_subject";
    ContentCustomizationInjectionPointApi["FUNDING_REQUIRED_EMAIL_BODY"] = "funding_required_email_body";
    ContentCustomizationInjectionPointApi["COLLEAGUE_AWARDED_PROJECT_EMAIL_SUBJECT"] = "colleague_awarded_project_email_subject";
    ContentCustomizationInjectionPointApi["COLLEAGUE_AWARDED_PROJECT_EMAIL_BODY"] = "colleague_awarded_project_email_body";
    ContentCustomizationInjectionPointApi["COMPLIANCE_QUEUE_AGENT_DIGEST_EMAIL_SUBJECT"] = "compliance_queue_agent_digest_email_subject";
    ContentCustomizationInjectionPointApi["COMPLIANCE_QUEUE_AGENT_DIGEST_EMAIL_BODY"] = "compliance_queue_agent_digest_email_body";
    ContentCustomizationInjectionPointApi["COMPLIANCE_QUEUE_AGENT_REMINDER_EMAIL_SUBJECT"] = "compliance_queue_agent_reminder_email_subject";
    ContentCustomizationInjectionPointApi["COMPLIANCE_QUEUE_AGENT_REMINDER_EMAIL_BODY"] = "compliance_queue_agent_reminder_email_body";
})(ContentCustomizationInjectionPointApi || (ContentCustomizationInjectionPointApi = {}));
export var ContentCustomizationEntityTypeApi;
(function (ContentCustomizationEntityTypeApi) {
    ContentCustomizationEntityTypeApi["ENTERPRISE"] = "enterprise";
})(ContentCustomizationEntityTypeApi || (ContentCustomizationEntityTypeApi = {}));
export var CustomCtaContextTypeApi;
(function (CustomCtaContextTypeApi) {
    CustomCtaContextTypeApi["BANNER"] = "banner";
})(CustomCtaContextTypeApi || (CustomCtaContextTypeApi = {}));
export var CustomCtaActionApi;
(function (CustomCtaActionApi) {
    CustomCtaActionApi["MODAL"] = "modal";
    CustomCtaActionApi["LINK"] = "link";
})(CustomCtaActionApi || (CustomCtaActionApi = {}));
export var CustomBannerEntityTypeApi;
(function (CustomBannerEntityTypeApi) {
    CustomBannerEntityTypeApi["ENTERPRISE"] = "enterprise";
})(CustomBannerEntityTypeApi || (CustomBannerEntityTypeApi = {}));
export var CustomBannerLocationApi;
(function (CustomBannerLocationApi) {
    CustomBannerLocationApi["DASHBOARD"] = "dashboard";
})(CustomBannerLocationApi || (CustomBannerLocationApi = {}));
export var CustomBannerTextColorApi;
(function (CustomBannerTextColorApi) {
    CustomBannerTextColorApi["DARK"] = "dark";
    CustomBannerTextColorApi["LIGHT"] = "light";
})(CustomBannerTextColorApi || (CustomBannerTextColorApi = {}));
export var GuidelineContextTypeApi;
(function (GuidelineContextTypeApi) {
    GuidelineContextTypeApi["CONTEST"] = "contest";
})(GuidelineContextTypeApi || (GuidelineContextTypeApi = {}));
